<template>
  <div >
    <!--搜索栏-->
    <header class="bar bar-nav">
      <button class="button button-link button-nav pull-left">
        <span class="icon icon-left goback" @click="goback()" v-if="!isWapp"></span>
      </button>
      <div class="searchbar title searchbox">
        <a class="searchbar-cancel cancel" style="color: #808080;" @click="cancelSearch">取消</a>
        <div class="search-input">
          <form action="#" @submit.prevent="onSearch">
            <label class="icon icon-search" for="search" v-if="showSearchIcon"></label>
            <input type="search" id='search' results='0' autocomplete="off" placeholder='输入基因名称...' v-model.trim="searchWords" @focus="onSearchActive(true)" @blur="onSearchActive(false)"/>
          </form>
        </div>
      </div>
    </header>
    <!--过滤选项工具条-->
    <div class="bar bar-header-secondary filter-bar" v-if="showFilterBar" style="height: auto;overflow-x: hidden" >
      <div class="checkbox-el" v-for="item in selectedItems">
        <label class="checkbox selected" v-if="item.selected"> {{item.word}}</label>
      </div>
      <!--<div class="checkbox-el">-->
        <!--<label class="checkbox selected">过表达</label>-->
      <!--</div>-->
      <!--<div class="checkbox-el">-->
        <!--<label class="checkbox selected">广谱启动子</label>-->
      <!--</div>-->
      <!--<div class="checkbox-el">-->
        <!--<label class="checkbox selected">光遗传</label>-->
      <!--</div>-->

      <div class="checkbox-el pull-right">
        <a style="width: 2rem;padding-right: 1rem" @click="cancelSearch" v-if="searchWords !== ''">清除搜索词</a>
        <a style="width: 2rem;" class="pull-right open-panel" @click="openpanel" data-panel='#panel-right-finder'>筛选</a>
      </div>
    </div>
    <div class="bar bar-header-secondary filter-bar" v-if="!showFilterBar && searchWords !== '' " style="height: auto">
      <div style="float: right">
        <a style="width: 2rem;" @click="cancelSearch" >清除搜索词</a>
      </div>
    </div>
    <!-- Icons in standard bar fixed to the bottom of the screen -->
    <div class="bar bar-footer status" v-if="showStatusBar">
      {{statusMsg}}
    </div>
    <div class="content" style="background-color: white">
      <div v-if="!showMatchData" style="margin-left: .8rem;font-size: .6rem">
        <div>为了您更好的体验，建议您：</div>
        <div>1.NCBI Refseq数据库基因使用Official Symbol；</div>
        <div>2. microRNA请使用mirbase数据库名称,比如microRNA155,若物种为human可以转化为hsa-mir-155,hsa-mir-155-5p,hsa-mir-155-3p；</div>
        <div>3.若您使用过程中碰到任何问题,可以返回首页咨询在线客服。</div>
      </div>
      <div class="search_history" v-if="searchHistory && searchHistory.length && !showMatchData">
        <div class="list-block">
          <ul>
            <div class="blueTitle"></div>
            <div class="content-block-title" style="margin-top: 10px;margin-bottom: 10px;">搜索历史</div>
            <div class="content-block-title" style="margin-top: -1.2rem;margin-left: 86%;color:#f6383a" @click="removeSearchHistory">清空</div>
            <li class="item-content close-popup" v-for="(item, index) in searchHistory" v-if="!isRemoveSH">
              <div class="item-inner" @click="searchTarget(item, false, true)">
                <div class="item-title close-popup">
                  {{item.text}}
                </div>
                <!--<div class="item-after">-->
                  <!--<span class="badge" v-for="tag in item.tags">{{tag}}</span>-->
                <!--</div>-->
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="list-block"  v-if="showMatchData" >

        <ul id="list" v-if="matchData !== undefined &&  !isCorrections ">
          <li class="item-content close-popup" v-for="searchData in matchData">
            <div class="item-inner" @click="searchTarget(searchData, true)">
              <div id="results-goods" class="item-title close-popup">
                {{searchData.text}}
              </div>
              <!--<div class="item-after">-->
              <!--<span class="badge" v-for = "tag in searchData.tags">{{tag}}</span>-->
              <!--</div>-->
            </div>
          </li>
        </ul>
        <ul v-if=" isCorrections && searchWords !== ''" style="background-color: inherit;border: 0 solid; font-size: 0.6rem">
          <p style="text-align: center">暂时没有匹配到与"<span style="color: #0894ec;">{{searchWords}}</span>"相关的线上产品信息，</p>
          <p style="text-align: center" v-if="isCorrections" >您也许可以试一下关键字

            <span @click="searchTarget(correctData, true)" style="color: #0894ec;margin-left: .2rem" v-for="correctData in matchData"><u>{{correctData.text}}</u></span>&nbsp;

          </p>
          <!--<div align="center"><img src="../../../static/img/nothingsearch.png"/></div>-->
          <div style="margin-left: .8rem;">
            <hr style="color: #e7e7e7;">
            <div>您也可以点击<span style="color: #0894ec;" @click="contactUs">联系方式</span></div>
            <div>或者点击<span style="color: #0894ec;" @click="toMessage">在线客服</span>咨询</div>
            <div>我们将会为您提供更多的产品和服务信息</div>
          </div>
        </ul>
      </div>
    </div>
    <!--Finder 内容区域-->
    <div class="content finder-content infinite-scroll" v-if="showfinderContent"   id="contentscroll">
      <!--取消商城现货快速入口-->
      <!--<div>-->
        <!--<div class="content-block-title filter-title" style="color: gray;font-size: .7rem">商城现货产品快速入口</div>-->
        <!--<div class="list-block filter-block">-->
          <!--<ul class="filter-block-ul">-->
            <!--<li class="item-content filter-opts">-->
              <!--<label style="font-size: .65rem;" class="category">-->
              <!--<a class="span-text"  style="border-bottom: 1px solid ;border-color:#0894ec;background-color: transparent" @click="gotoCategry(9, '工具类病毒')" >工具类病毒</a>-->
              <!--</label>-->
              <!--<label style="font-size: .65rem;" class="category">-->
                <!--<a class="span-text"  style="border-bottom: 1px solid ;border-color:#0894ec;background-color: transparent" @click="gotoCategry(8, 'Cas9文库')" >Cas9文库</a>-->
              <!--</label>-->
              <!--<label style="font-size: .65rem;" class="category">-->
                <!--<a class="span-text"  style="border-bottom: 1px solid ;border-color:#0894ec;background-color: transparent" @click="gotoCategry(5, '工具类AAV')" >工具类AAV</a>-->
              <!--</label>-->
              <!--<label style="font-size: .65rem;" class="category">-->
                <!--<a class="span-text"  style="border-bottom: 1px solid ;border-color:#0894ec;background-color: transparent" @click="gotoCategry(6, '细胞')" >细胞</a>-->
              <!--</label>-->
              <!--<label style="font-size: .65rem;" class="category">-->
                <!--<a class="span-text"  style="border-bottom: 1px solid ;border-color:#0894ec;background-color: transparent" @click="gotoCategry(7, '试剂')" >试剂</a>-->
              <!--</label>-->
              <!--<label style="font-size: .65rem;" class="category">-->
                <!--<a class="span-text"  style="border-bottom: 1px solid ;border-color:#0894ec;background-color: transparent" @click="gotoCategry(1, '引物')" >引物</a>-->
              <!--</label>-->
              <!--&lt;!&ndash;<label class="label-checkbox checkbox-el filter-el" >&ndash;&gt;-->
                <!--&lt;!&ndash;<input type="checkbox" name="my-checkbox">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="item-media checkbox filter-checkbox " style="color: #1e7be6 " @click="gotoCategry(9, '工具类病毒')"><div class="span-text" >工具类病毒</div></div>&ndash;&gt;-->
              <!--&lt;!&ndash;</label>&ndash;&gt;-->
              <!--&lt;!&ndash;<label class="label-checkbox checkbox-el filter-el">&ndash;&gt;-->
                <!--&lt;!&ndash;<input type="checkbox" name="my-checkbox">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="item-media checkbox filter-checkbox" style="color: #1e7be6 " @click="gotoCategry(8, 'Cas9文库')"><div class="span-text">Cas9文库</div></div>&ndash;&gt;-->
              <!--&lt;!&ndash;</label>&ndash;&gt;-->
              <!--&lt;!&ndash;<label class="label-checkbox checkbox-el filter-el">&ndash;&gt;-->
                <!--&lt;!&ndash;<input type="checkbox" name="my-checkbox">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="item-media checkbox filter-checkbox" style="color: #1e7be6 " @click="gotoCategry(5, '工具类AAV')"><div class="span-text">工具类AAV</div></div>&ndash;&gt;-->
              <!--&lt;!&ndash;</label>&ndash;&gt;-->
              <!--&lt;!&ndash;<label class="label-checkbox checkbox-el filter-el">&ndash;&gt;-->
                <!--&lt;!&ndash;<input type="checkbox" name="my-checkbox">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="item-media checkbox filter-checkbox" style="color: #1e7be6 " @click="gotoCategry(6, '细胞')"><div class="span-text">细胞</div></div>&ndash;&gt;-->
              <!--&lt;!&ndash;</label>&ndash;&gt;-->
              <!--&lt;!&ndash;<label class="label-checkbox checkbox-el filter-el">&ndash;&gt;-->
                <!--&lt;!&ndash;<input type="checkbox" name="my-checkbox">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="item-media checkbox filter-checkbox" style="color: #1e7be6 " @click="gotoCategry(7, '试剂')"><div class="span-text">试剂</div></div>&ndash;&gt;-->
              <!--&lt;!&ndash;</label>&ndash;&gt;-->
              <!--&lt;!&ndash;<label class="label-checkbox checkbox-el filter-el">&ndash;&gt;-->
                <!--&lt;!&ndash;<input type="checkbox" name="my-checkbox">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="item-media checkbox filter-checkbox" style="color: #1e7be6 " @click="gotoCategry(1, '引物')"><div class="span-text">引物</div></div>&ndash;&gt;-->
              <!--&lt;!&ndash;</label>&ndash;&gt;-->
            <!--</li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->
      <!--过滤选项区域-->
    <finderFilter v-if="showFilter" :findFilters="findFilters" v-on:finderFilterSearch="finderFilterSearch" :finderyemian="true"></finderFilter>
      <!--搜索内容区-->
    <newMerchandiseListA :merchList="finderResultData" ref=”a” class="list-container"></newMerchandiseListA>
      <div style="font-size: .6rem;text-align: center" v-if="finderEnd">
        <p >更多产品请联系<a @click="toMessage">在线客服</a>或者拨打400-621-0302</p>
        <!--<p>如果没有找到您要的产品，请联系在线客服或者拨打400-621-0302转8012</p>-->
      </div>
      <div class="infinite-scroll-preloader" id='preloader' v-else>
        <div class="preloader"></div>
      </div>
      <a id="btnTop" style="display:none;" @click="returntop" class="btnTop" href="javascript:;" title="Back to top">
        <img src="../../../static/img/top.png" class="imageTop" style="height: 50px">
      </a>
      <!--<newMerchandiseListB></newMerchandiseListB>-->
      <!--<newMerchandiseListC></newMerchandiseListC>-->

    </div>


  </div>
</template>
<script>
  import emkt from '../../emkt'
  // eslint-disable-next-line
  import finderFilter from './FinderFilter.vue'
  import newMerchandiseListA from './components/NewMerchandiseListA'
  import newMerchandiseListB from './components/NewMerchandiseListB'
  import newMerchandiseListC from './components/NewMerchandiseListC'
  import {mapGetters, mapState, mapMutations} from 'vuex'
  import $ from 'jquery'
  export default {
    mounted () {
      if (this.emkt.getLocalStorage('EmktFinderHistory')) {
        this.searchHistory = this.emkt.getLocalStorage('EmktFinderHistory')
      }
//      var self = this
//      $(function () {
//        $('.popup .searchTr .searchBox').click(function () {
//          $(this).toggleClass('selected')
//
//          self.selectedTags = []
//          let selectTags = $('.popup .searchTr')[0].getElementsByClassName('selected')
//          for (let i = 0; i < selectTags.length; i++) {
//            self.selectedTags.push(selectTags[i].innerHTML)
//          }
//          if (this.searchWords !== '') {
//            self.response()
//          }
//        })
//        $('.close-popup').click(function () {
//          self.searchWords = ''
//        })
//      })
//      this.fetchData()
      window.addEventListener('scroll', this.handleScrollsss, true)
    },
    created () {
      this.fetchData()
    },
    activated () {
      const content = `<div id="lottery"><img style="width: 12rem;" src="${this.attrurl}finder_intro.png"></div>`
      if (this.showProductImage === false) {
        return
      }
      this.$weui.dialog({
        title: '产品简介',
        content: content,
        buttons: [{
          type: 'primary',
          label: '我知道了',
          onClick: () => {
            this.SET_SHOW_PRODUCT_IMAGE(false)
          }
        }]
      })
      // $.modal({
      //   title: '产品简介',
      //   text: content,
      //   buttons: [ {
      //     text: '我知道了',
      //     onClick: () => {
      //       this.SET_SHOW_PRODUCT_IMAGE(false)
      //     }
      //   }]
      // })
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScrollsss, true)
    },
    ready () {
    },
    data () {
      return {
        uiOptions: {
          searchActive: false
        },
        searchWords: '',
        matchData: [],
        finderResultData: [],
        oldSearchWords: '',
        statusMsg: ' ',
//        showFilterBar: false,
        showfinderContent: true,
        showMatchData: false,
        showFilter: true,
        searchHistory: [],
        hotWords: [],
        data: [],
        c: [],
        searchValue: '',
        tags: [],
        selectedTags: [],
        keywordMeanings: [],
        param: {},
        lastIndex: 20,
        maxitem: 0,
        showFilterBarValue: false,
        isRemoveSH: false,
        finderEnd: false,
        loading: false,
        flag: false,
        isCorrections: false,
        attrurl: '/emktResources/resocurces/img/promotion/',
        isWapp: emkt.isWapp
      }
    },
    watch: {
      searchWords: function (words) {
        this.searchAssociate()
      },
      $route () {
        var param = {}
        var _this = this
        if (_this.$route.params.ishome) {
          param.text = ''
          param.fromIndex = 0
          param.findFilters = []
          if (_this.ÏisSFFlag === true) {
            param.findSource = emkt.FindSourceCrm
          }
          _this.FINDER_FLAG(false)
          _this.showFilter = true
          _this.loading = false
          _this.showFilterBarValue = false
          _this.finderEnd = false
          window.addEventListener('scroll', this.handleScrollsss, true)
          _this.gcapi('find', param).then((response) => {
            _this.FINDER_RESULT_TOTAL(response.body.result.total)
            _this.FIND_FILTERS(response.body.result.findFilters)
            _this.finderResultData = response.body.result.merchandiseList
            _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
              return o1.selfOperated - o2.selfOperated
            })
            console.log(response.body.result)
          })
        }
      },
      'finderFlag': function () {
        var _this = this
        if (_this.finderFlag) {
//          if (_this.$route.params.ishome) {
//            _this.$route.params.ishome = false
//          }
          var param = {}
          param.text = _this.searchWords
          param.fromIndex = 0
          param.findFilters = this.findFilters
          if (_this.isSFFlag === true) {
            param.findSource = emkt.FindSourceCrm
          }
          _this.gcapi('find', param).then((response) => {
            _this.FIND_FILTERS(response.body.result.findFilters)
//            _this.findFilters = response.body.result.findFilters
            _this.FINDER_RESULT_TOTAL(response.body.result.total)
            _this.finderResultData = response.body.result.merchandiseList
            _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
              return o1.selfOperated - o2.selfOperated
            })
            if (_this.finderResultData.length >= 20) {
              _this.finderEnd = false
            } else {
              _this.finderEnd = true
            }
//            _this.returntop()
            _this.say('为您找到' + _this.finderResultTotal + '条结果')
          })
        }
        this.FINDER_FLAG(false)
      }
    },
//    components: {
//      finderContent
//    },
    components: {
      finderFilter, newMerchandiseListA, newMerchandiseListB, newMerchandiseListC
    },
    computed: {
      ...mapGetters([
        'hasLogin', 'isSFFlag'
        // ...
      ]),
      ...mapState([
        'showProductImage'
      ]),
      showSearchIcon: function () {
        // 如果查询输入框处于激活状态，不要显示搜索ICON
        if (this.uiOptions.searchActive) {
          this.showfinderContent = false
          return false
        }
        // 如果查询输入框有查询内容，也不要显示搜索ICON
        if (this.searchWords !== '') {
          return false
        }

        return true
      },
      selectedItems: function () {
        var items = []
        this.findFilters.forEach(function (item) {
          item.filterItems.forEach(function (data) {
            if (data.selected) {
              items.push(data)
            }
          })
        })
        return items
      },
      showFilterBar: function () {
        return this.showFilterBarValue
      },
      showStatusBar: function () {
        return this.statusMsg !== ''
      },
      ...mapState([
        'findFilters', 'finderResultTotal', 'finderFlag'
      ])
    },
    methods: {
      ...mapMutations([
        'FIND_FILTERS', 'FINDER_RESULT_TOTAL', 'FINDER_FLAG', 'SET_SHOW_PRODUCT_IMAGE'
      ]),
      fetchData () {
        var _this = this
        var param = {}
        if (_this.$route.query.ishome) {
          param.text = ''
          param.fromIndex = 0
          param.findFilters = []
          if (_this.isSFFlag === true) {
            param.findSource = emkt.FindSourceCrm
          }
          _this.FINDER_FLAG(false)
          _this.gcapi('find', param).then((response) => {
            _this.FIND_FILTERS(response.body.result.findFilters)
            _this.finderResultData = response.body.result.merchandiseList
            _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
              return o1.selfOperated - o2.selfOperated
            })
            console.log(response.body.result)
          })
          return
        }
        param.text = _this.searchWords
        param.fromIndex = _this.finderResultData.length
        param.findFilters = []
        if (_this.isSFFlag === true) {
          param.findSource = emkt.FindSourceCrm
        }
        _this.FINDER_FLAG(false)
        _this.gcapi('find', param).then((response) => {
          _this.FIND_FILTERS(response.body.result.findFilters)
          _this.finderResultData = response.body.result.merchandiseList
          _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
            return o1.selfOperated - o2.selfOperated
          })
          console.log('find', response.body.result)
        })
        _this.say('')
      },
      gotoCategry (id, label) {
        emkt.customerBehaviours.category.goToCategoryDetail = {'time': Date.parse(new Date()), 'target': id, 'type': emkt.customerBehaviourType.click}
        this.$router.push({path: '/categoryDetail', query: { id: id, label: label }})
      },
      goback () {
        if (this.showMatchData) {
          this.cancelSearch()
        } else {
          this.cancelSearch()
          window.removeEventListener('scroll', this.handleScrollsss, true)
          this.$router.go(-1)
        }
//        this.$router.push({name: 'home'})
      },
      contactUs () {
        this.$router.push({name: 'contactUs'})
      },
      finderFilterSearch () {
        this.FINDER_FLAG(true)
      },
      toMessage () {
        if (this.hasLogin) {
          emkt.openCustomerService()
          // window.open('https://im.7x24cc.com/phone_webChat.html?accountId=N000000017411&chatId=781fc95d-30dc-4aa2-aaa6-6a6a05ca2258')
        } else {
          alert('请您先去登录！')
        }
//        this.$router.push({name: 'myMessage', query: {merchandiseurl: this.$route.fullPath}})
      },
      returntop () {
        var _this = this
        _this.finderEnd = false
//        var btnTop = document.getElementById('btnTop')
//        btnTop.style.display = 'none'
        var timer = setInterval(function () {
          var sTop
          if (document.compatMode === 'BackCompat') {
            sTop = document.body.scrollTop
          } else {
            sTop = document.getElementById('contentscroll').scrollTop || document.body.scrollTop || window.pageYOffset
          }
          var backTop = sTop
          var speedTop = backTop / 10
          _this.setScrollTop(backTop - speedTop)
          if (backTop === 0) {
            clearInterval(timer)
          }
        }, 30)
      },
      setScrollTop (top) {
        if (document.compatMode === 'BackCompat') {
          document.body.scrollTop = top
        } else {
          if (document.getElementById('contentscroll').scrollTop.scrollTop === 0) {
            document.body.scrollTop = top
          } else {
            document.getElementById('contentscroll').scrollTop = top
          }
        }
      },
      handleScrollsss () {
        if (this.$route.name === 'finder') {
          var _this = this
          var btnTop = document.getElementById('btnTop')
          var visibleBottom = window.scrollY + document.documentElement.clientHeight
//          console.log('visibleBottom:' + visibleBottom)
//          console.log(' scrollTop:' + document.getElementById('contentscroll').scrollTop)
          if (document.getElementById('contentscroll').scrollTop > 1200) {
            if (_this.showFilter) {
              _this.showFilter = false
              _this.showFilterBarValue = true
            }
          }
          if (document.getElementById('contentscroll').scrollTop > 1200) {
            btnTop.style.display = 'block'
          } else {
            btnTop.style.display = 'none'
          }
          if (!_this.loading) {
            if (document.getElementById('preloader')) {
              var centerY = document.getElementById('preloader').offsetTop + (document.getElementById('preloader').offsetHeight / 2)
              if (centerY <= document.getElementById('contentscroll').scrollTop + visibleBottom) {
//              $.detachInfiniteScroll($('.infinite-scroll'))
//              $('.infinite-scroll-preloader').remove()
                var length = _this.finderResultData.length
                if (_this.finderResultData.length >= length) {
                  _this.loading = true
                  _this.finderEnd = false
                  var param = {}
                  if (_this.isSFFlag === true) {
                    param.findSource = emkt.FindSourceCrm
                  }
                  param.text = _this.searchWords
                  param.fromIndex = _this.finderResultData.length
                  param.findFilters = _this.findFilters
                  this.gcapi('find', param).then((response) => {
                    var addlist = response.body.result.merchandiseList
                    length = length + addlist.length
                    if (addlist.length >= 20) {
                      for (var i = 0; i < addlist.length; i++) {
                        _this.finderResultData.push(addlist[i])
                      }
                    } else {
                      _this.finderEnd = true
                    }
                    _this.loading = false
                  })
                }
              }
            }
          }
//          if (_this.loading) return
        }
      },
      openpanel () {
        $.openPanel('#panel-right-finder')
      },
      handleScroll () {
        this.scroll = document.body.scrollTop
        console.log(this.scroll)
      },
      onSearchActive (active) {
        this.uiOptions.searchActive = active

        if (this.uiOptions.searchActive) {
          this.oldSearchWords = this.searchWords
        } else {
          // search input 失去焦点
          if (this.oldSearchWords !== this.searchWords) {
            // 恢复原来的searchWords
            // this.searchWords = this.oldSearchWords
            this.oldSearchWords = this.searchWords
          }
        }
      },
      onSearch () {
        this.oldSearchWords = this.searchWords
        window.$('input[type=search]').blur()
//        this.showfinderContent = false
//        this.showMatchData = true
        var _this = this
        if (!_this.matchData || _this.matchData.length < 1) {
          return
        }
        $.showPreloader('正在查询结果,请稍等')
        _this.loading = true
        _this.finderEnd = false
        var param = {}
        if (_this.isSFFlag === true) {
          param.source = emkt.FindSourceCrm
        }
        param.text = _this.searchWords
        param.fromIndex = 0
        param.findFilters = []
        _this.gcapi('find', param).then((response) => {
          console.log('onSearch', this.searchWords, response)
          const merchList = response.body.result.merchandiseList
          if (merchList) {
            _this.addSearchWordIntoAbstractList(merchList)
          }
          _this.finderResultData = merchList
          _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
            return o1.selfOperated - o2.selfOperated
          })
          _this.FIND_FILTERS(response.body.result.findFilters)
          _this.FINDER_RESULT_TOTAL(response.body.result.total)
          _this.lastIndex = _this.finderResultData.length
          if (_this.finderResultData.length > 0) {
            _this.showfinderContent = true
            _this.showMatchData = false
            console.log(response.body.result.total)
            _this.say('为您找到' + _this.finderResultTotal + '条结果')
          } else {
            _this.say('查询无结果')
          }
          // console.log('onSearch', response.body.result)
//          this.finderResultData = response.body.result.merchandiseList
//          if (this.finderResultData.length > 0) {
//            this.showfinderContent = true
//          }
        }).then($.hidePreloader())
        console.log('search1 ' + this.searchWords)
      },
      cancelSearch () {
        var param = {}
        param.text = ''
        param.fromIndex = 0
        param.findFilters = []
        this.FINDER_FLAG(false)
        this.gcapi('find', param).then((response) => {
          this.FIND_FILTERS(response.body.result.findFilters)
          this.finderResultData = response.body.result.merchandiseList
          this.finderResultData && this.finderResultData.sort(function (o1, o2) {
            return o1.selfOperated - o2.selfOperated
          })
        })
        this.say('')
        window.$('input[type=search]').blur()
        this.showfinderContent = true
        this.showMatchData = false
        this.searchWords = ''
        console.log('search2 ' + this.searchWords)
      },
      // 搜索联想
      searchAssociate () {
        // 截流
        emkt.throttle(this.doSearchAssociate, 500, this)
      },
      doSearchAssociate () {
        var _this = this
        if (_this.searchWords === _this.oldSearchWords) {
          return
        }
        _this.gcapi('findSuggestion', _this.searchWords).then((res) => {
          _this.matchData = res.body.result
          if (_this.matchData && _this.matchData.length > 0 && _this.matchData[0].isCorrections === true) {
            _this.isCorrections = _this.matchData[0].isCorrections
          } else {
            _this.isCorrections = false
          }
          _this.showMatchData = true
        })
        console.log('search3 associate ' + _this.searchWords)
        this.say('')
      },
      removeSearchHistory () {
        window.localStorage.removeItem('EmktFinderHistory')
        this.searchHistory = this.emkt.getLocalStorage('EmktFinderHistory')
        this.emkt.removeStoreItem('EmktFinderHistory')
        this.isRemoveSH = true
      },
      getHistoryData (selectedItem) {
        /**
         * 点击搜索结果进入下一页面时进行判断是否已经有一样的历史记录
         * 如果没有则新增，如果有则不做重复储存，判断完成后进入下一页
         */
        let searchHistory = this.emkt.getLocalStorage('EmktFinderHistory') === undefined ? [] : this.emkt.getLocalStorage('EmktFinderHistory')
        if (searchHistory) {
          let checkrepeat = false
          searchHistory.forEach(item => {
            if (item.text === selectedItem.text) {
              checkrepeat = true
            }
          })
          if (!checkrepeat) {
            if (searchHistory.length >= 5) {
              searchHistory.splice(0, 1)
            }
            searchHistory.push(selectedItem)
          }
        } else if (selectedItem && selectedItem.text !== '') {
          if (searchHistory.length >= 5) {
            searchHistory.splice(0, 1)
          }
          searchHistory.push(selectedItem)
        }
        this.emkt.setLocalStorage('EmktFinderHistory', searchHistory)
        this.searchHistory = this.emkt.getLocalStorage('EmktFinderHistory')
        this.isRemoveSH = false
      },
      searchTarget (selectedItem, needCondition, fromHistory) {
        var _this = this
        _this.searchValue = selectedItem.text
        _this.searchWords = selectedItem.text
        $.showPreloader('正在查询结果,请稍等')
        var param = {}
        param.text = _this.searchWords
        param.fromIndex = 0
        param.findFilters = []
        this.getHistoryData(selectedItem)

        if (fromHistory) {
          // do nothing
        } else {
          param.queryNos = selectedItem.queryNos
        }

        _this.gcapi('find', param).then((response) => {
          _this.finderResultData = response.body.result.merchandiseList
          _this.finderResultData && _this.finderResultData.sort(function (o1, o2) {
            return o1.selfOperated - o2.selfOperated
          })
          _this.FIND_FILTERS(response.body.result.findFilters)
          _this.FINDER_RESULT_TOTAL(response.body.result.total)
          _this.lastIndex = _this.finderResultData.length
          if (_this.finderResultData.length > 0) {
            _this.showfinderContent = true
            _this.showMatchData = false
            _this.showFilter = true
            _this.showFilterBarValue = false
            _this.say('为您找到' + _this.finderResultTotal + '条结果')
          } else {
            $.toast('查询无结果')
          }
          console.log(response.body.result)
//          this.finderResultData = response.body.result.merchandiseList
//          if (this.finderResultData.length > 0) {
//            this.showfinderContent = true
//          }
        }).then($.hidePreloader())
      },
      controlForm (attribute, index) {
        console.log(attribute)
        console.log(index)
      },
      say (msg) {
        this.statusMsg = msg
      },
      addSearchWordIntoAbstractList (merchList) {
        if (!merchList || merchList.length === 0) {
          return
        }
        // 若首个商品的_abstractList已包含搜索关键字，直接返回
        let searchWordIncluded = false
        for (let merchandise of merchList) {
          searchWordIncluded = false
          for (let attr of merchandise._abstractList) {
            if (attr.valueText && attr.valueText.toLowerCase() === this.searchWords.toLowerCase()) {
              console.log('已包含关键字')
              searchWordIncluded = true
              break
            }
          }
          // 若商品的_abstractList不包含搜索关键字，手动添加
          if (!searchWordIncluded) {
            console.log('手动添加')
            merchandise._abstractList.push({
              'label': 'searchWord',
              'valueText': this.searchWords
            })
          }
        }
        return
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .search_history {
    background-color: #fff;
    margin-bottom: 0.4rem;
  }
  .blueTitle {
    width: 4rem;
    border-bottom: 2px solid #00469A;
  }
  .finder-content{
    background-color: white;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    padding-top: 0.2rem;
    padding-bottom: 0.1rem;
  }
  .bar-header-secondary~.content{top:3.9rem;}
  .bar-footer~.content{bottom:1.0rem}

  .searchbox {
    font-weight: 350;
    padding-left: 1.5rem;
  }
  .inactive {
    padding-left: 1.5rem;
  }
  .goback {
    color: gray;
  }
  .cancel {
    font-size: 0.7rem;
  }

  .status {
    height: 1rem;
    font-weight:150;
    font-size: 0.6em;
  }

  input[type="search"] {
    -webkit-user-select: auto; /*webkit浏览器*/
    user-select: auto;
    -o-user-select: auto;
    -ms-user-select: auto;
  }

  /*
  input[type="checkbox"] {
    display: none;
  }
  */
  .filter-bar {
    line-height:1.4rem;
    color:#3d4145;
    height: 1.7rem;
    margin:0rem -.3rem;
    padding: 0rem 0.5rem 0.3rem 0.5rem;
    /*
    padding:0;
    display:block;
    width:100%;
    text-align:center;
    position:absolute;
    margin:0 -.5rem;
    font-size:.85rem;
    font-weight:150;
    white-space:nowrap;

    */
  }
  .checkbox-el {
    display: inline-block;
    text-align: left;
  }
  .checkbox {
    display: inline-block;
    text-decoration: none;
    color: #878787; /*8b8b8b*/
    font-weight: normal;
    font-style: normal;
    font-size: .6rem;
    /*font-weight:200;*/
    line-height: 1;
    background-color: #f9f9f9; /*#f0f0f0*/
    padding: 0.5em;
    border-radius:.25rem;
    text-align: center;
    /*width: 3rem;*/

  }
  .small-checkbox {
    display: inline-block;
    text-decoration: none;
    color: #878787; /*8b8b8b*/
    font-weight: normal;
    font-style: normal;
    font-size: .4rem;
    /*font-weight:200;*/
    line-height: 1;
    background-color: #f9f9f9; /*#f0f0f0*/
    text-align: center;
    /*width: 3rem;*/

  }
  .small-filter-el {
    margin-top: 0.2rem;
    margin-bottom: 0.1rem;
    margin-right: 0.2rem;
    margin-left: 0.1rem;
  }
  .checkbox.selected {
    color: #1E90FF;/*#4169E1;*/
    background-color: rgba(105, 162, 255, 0.21);
  }

  /*搜索选项区*/
  .filter-title{
    margin-top: 0.3rem;
    margin-bottom: 0rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    color: #1e7be6;
    font-weight: normal;
    font-style: normal;
    font-size: 0.6rem;
  }
  .filter-block{
    margin-top: 0.1rem;
    margin-bottom: 0.5rem;
  }
  .filter-block-ul{
    border-top: none;
    border-bottom: none;
  }
  .filter-opts{
    margin-left: 0rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.0rem;
    padding-bottom: 0.0rem;

    min-height: 1rem;
    display: block;
    vertical-align: center;
  }
  .filter-el {
    margin-top: 0.2rem;
    margin-bottom: 0.1rem;
    margin-right: 0.1rem;
    margin-left: 0.1rem;
  }
  .filter-checkbox {
    min-width: 3.8rem;
  }
  /*搜索内容区*/
  .item-inner {
    display: block;
  }
  .item-title {
    font-size: 0.6rem;
  }
  .sub-span {
    font-size: 0.5rem;
    color: white;
    background-color: #00469A;padding: 0.1rem;border-radius:.25rem;
  }
  .infinite-scroll-preloader {
    margin-top:-20px;
  }
  .bar-footer {
    font-size: .8rem;
    color: #1e7be6;
  }
  .category{
    margin-left: .4rem;
  }
  .btnTop { position: fixed; right: 2%; bottom: 2%; cursor: pointer; opacity: .7; z-index: 9; }
  .btnTop:hover { opacity: 1;}
  .imageTop { height: 72px; height: 72px;}
</style>



// WEBPACK FOOTER //
// Finder.vue?2a49193e